<script lang="ts" setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { STORAGE_DEBUG, STORAGE_OPEN_ID, STORAGE_TOKEN } from '@/constants'

const router = useRouter()
const route = useRoute()

const token = ref((route.query.token as string) ?? window.localStorage.getItem(STORAGE_TOKEN) ?? '')
const openId = ref((route.query.openId as string) ?? window.localStorage.getItem(STORAGE_OPEN_ID) ?? '')
function onMockLogin() {
  if (!token.value)
    // eslint-disable-next-line no-alert
    return window.alert('请输入 `token`')

  window.localStorage.setItem(STORAGE_TOKEN, token.value)
  window.localStorage.setItem(STORAGE_OPEN_ID, openId.value)
  router.replace({ name: 'home' })
}

const debugMode = ref(window.localStorage.getItem(STORAGE_DEBUG) === '1')
function onToggleDebugMode() {
  if (debugMode.value)
    window.localStorage.removeItem(STORAGE_DEBUG)
  else
    window.localStorage.setItem(STORAGE_DEBUG, '1')

  debugMode.value = !debugMode.value
}
</script>

<template>
  <div class="min-h-screen bg-white">
    <BasicNavbar />

    <div class="px-5 pt-20">
      <div class="mt-4">
        <p class="font-bold">
          # 模拟登录
        </p>
        <textarea
          v-model="token" class="mt-4 w-full h-20 px-4 py-2 bg-#f8f8f8 rounded"
          placeholder="复制 `token` 到此文本框"
        />
        <input v-model="openId" class="mt-4 w-full px-4 py-2 bg-#f8f8f8 rounded" placeholder="openId">
        <div class="flex justify-end">
          <button
            class="mt-4 px-4 py-2 text-white bg-black rounded"
            @click="onMockLogin"
          >
            登录
          </button>
        </div>
      </div>

      <!-- Toggle debug mode -->
      <div class="mt-4">
        <p class="font-bold">
          # DEBUG(vConsole)
        </p>
        <div class="flex justify-between mt-4">
          <button
            class="px-4 py-2 text-white bg-black rounded"
            @click="onToggleDebugMode"
          >
            {{ debugMode ? '关闭' : '开启' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
